import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { withTranslation, useTranslation } from 'react-i18next'
import { capitalize } from 'srcReact/helpers/utils'
import { authenticationActions } from 'srcReact/redux/actions/authentication'

import Button from 'srcReact/components/common2/Button'
import Pill from 'srcReact/components/common2/Pill'
import Accordion from 'srcReact/components/common/AccordionComponent'

import datasAccordions from '../../datasAccordions'

import styles from './styles.module.scss'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Spinner from 'srcReact/components/common2/Spinner'

const SuccessStep = ({
  isMobile,
  formState,
  setSuccess,
  newAccountDatas,
  createAccount,
  createAccountLoading,
  updateStep,
  setPreviousStep,
  setFormState
}) => {
  const interestsList = formState.selectedInterests.map((e) => <Pill selected={true} key={e.id} text={e.name} />)
  const { t } = useTranslation()
  const accordion = datasAccordions(t)

  const { createAccountError } = useSelector((state) => state.authentication)
  const hasWorkplaceInvitations = formState.workplace_invitations.length > 0

  const getOrgName = (orgId) => {
    let ssoOrgList = localStorage.getItem('ssoOrgList')
    if (ssoOrgList) {
      ssoOrgList = JSON.parse(ssoOrgList)
    }
    if (ssoOrgList && ssoOrgList.length > 0) {
      let orgObj = ssoOrgList.find((org) => org.id == orgId)
      if (orgObj) {
        return orgObj.name
      } else {
        orgObj = formState.organizations?.find((org) => org.id == orgId)
        if (orgObj) {
          return orgObj.name
        }
      }
    } else {
      const orgObj = formState.organizations?.find((org) => org.id == orgId)
      if (orgObj) {
        return orgObj.name
      }
    }
    return ''
  }

  const messageWorkplace = hasWorkplaceInvitations
    ? t('signup.success_step.message_workplace.explore', {
        orgName: getOrgName(formState.workplace_invitations[0].organization_id),
        wpName: formState.workplace_invitations[0].name
      })
    : t('signup.success_step.message_workplace.create')

  useEffect(() => {
    const element = document.querySelector('#missed_invite_chg_email')
    if (element) {
      element.addEventListener('click', gotoEmailStep)
    }
    return () => {
      if (element) {
        element.removeEventListener('click', gotoEmailStep)
      }
    }
  }, [])

  const gotoEmailStep = () => {
    setSuccess(false)
    updateStep('email')
    setPreviousStep([])
    setFormState({
      ...formState,
      fromSuccessStep: true
    })
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.container1}>
        <div className={styles.container}>
          <div className={styles.backgroundPurple}></div>
          <div className={styles.container2}>
            {formState.profilePicturePath ? (
              <img src={formState.profilePicturePath} alt={formState.profilePicturePath} className={styles.image} />
            ) : (
              <div className={styles.image} />
            )}
            <div className={styles.name}>
              {capitalize(formState.firstName)} {capitalize(formState.lastName)}
            </div>
            {formState.preferred_pronoun && (
              <div className={styles.job}>
                {formState.preferred_pronoun.value === 'other'
                  ? formState.preferred_pronoun.label
                  : `(${formState.preferred_pronoun.label})`}
              </div>
            )}

            <div className={styles.pillContainer}>{interestsList}</div>
            <div className={styles.goBack} role='button' onClick={() => setSuccess(false)}>
              {t('signup.success_step.go_back')}
            </div>
            <div className={styles.accountReady}>{t('signup.success_step.ready_account')}</div>
            <div className={styles.description}> {messageWorkplace}</div>
            {createAccountError && <ErrorMessage text={createAccountError} className={styles.error} />}
            {createAccountLoading && <Spinner />}
            <Button
              disabled={createAccountLoading}
              size='large'
              text={
                hasWorkplaceInvitations
                  ? t('signup.success_step.button.text_1')
                  : t('signup.success_step.button.text_2')
              }
              handleClick={() => {
                createAccount(newAccountDatas)
              }}
            />
          </div>
        </div>
      </div>

      {formState && formState.workplace_invitations && formState.workplace_invitations.length === 0 ? (
        <div className={styles.missedInviteContainer}>
          <h1 className={styles.title}>{t('signup.success_step.missedInvite.title')}</h1>
          <h2
            className={styles.subtitle}
            dangerouslySetInnerHTML={{
              __html: t('signup.success_step.missedInvite.subtitle', { email: formState.email })
            }}
          />
        </div>
      ) : null}

      {isMobile && (
        <div>
          <Accordion data={accordion.success} customAccdnClass={styles.accordion} />
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  const {
    common: { isMobile },
    authentication: { createAccountLoading }
  } = state
  return {
    isMobile,
    createAccountLoading
  }
}

const actionCreators = {
  createAccount: authenticationActions.createAccount
}

const ExtendedComponent = withTranslation('common')(SuccessStep)

const connectedSuccessStep = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedSuccessStep as SuccessStep }
